<template>
  <el-dialog title="Complete round" :visible.sync="open" @closed="$emit('close')">
    <el-steps :active="tab" finish-status="success"  align-center class="steps">
      <el-step :title="question.title[lang]" v-for="(question, index) in round.questions" :key="index" />
    </el-steps>

    <main class="results" v-for="(question, index) in round.questions" :key="index" v-if="index === tab">
      <el-form v-if="question.type === 'score'">
        <el-form-item :label="question.values[0]">
          <el-input-number :min="0" v-model="responses[index][question.values[0]]" />
        </el-form-item>

        <el-form-item :label="question.values[1]">
          <el-input-number :min="0" v-model="responses[index][question.values[1]]" />
        </el-form-item>
      </el-form>

      <div v-if="question.type === 'qcu'">
        <el-select v-model="responses[index][0]" filterable placeholder="Select">
          <el-option v-for="(item, index) in question.values" :key="index" :label="item" :value="item" />
        </el-select>
      </div>
    </main>

    <span slot="footer">
      <el-button @click="tab--" v-if="tab > 0">Previous</el-button>
      <el-button @click="open = false" v-else>Cancel</el-button>
      <el-button type="primary" @click="tab++" v-if="tab < round.questions.length - 1">Next</el-button>
      <el-button type="primary" @click="save()" v-else>Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      round: null,

      open: true,
      tab: 0,
      responses: []
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('rounds', {
      roundById: 'roundById'
    })
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    ...mapActions('rounds', ['addResponses']),

    init () {
      if (this.site) {
        let round = this.roundById(this.id)
        this.round = this._.cloneDeep(round)

        this.round.questions.forEach((question) => {
          if (question.type === 'score') {
            this.responses.push({})
          } else {
            this.responses.push([])
          }
        })
      }
    },

    save () {
      let roundresponses = []

      this.responses.forEach((response, index) => {
        let resp

        if (this.round.questions[index].type === 'score') {
          resp = this.round.questions[index].values[0] + ' ' + response[this.round.questions[index].values[0]]
          resp += ' - '
          resp += response[this.round.questions[index].values[1]] + ' ' + this.round.questions[index].values[1]
        } else {
          resp = response[0]
        }

        roundresponses.push({
          questionid: this.round.questions[index].id,
          responses: [resp]
        })
      })

      this.addResponses({round: {id: this.round.id}, responses: {roundresponses: roundresponses}, sitekey: this.site.sitekey})
        .then(() => {
          this.$emit('close', true)
          this.$notify({ title: 'Success', message: this.$root.$t('notifications.round.responsesSaved'), type: 'success' })
        }).catch((e) => {
          this.$emit('close', true)
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    }
  }

}
</script>

<style lang="scss" scoped>
.results {
    margin-top: 80px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/rounds/round-completion.vue